import {field} from "@fedeltapointofsale/data-client";
import {ReportData} from "../../../reports/report.data";

export class BriefTillSummaryReportData extends ReportData<BriefTillSummaryReportData> {
    @field floatId: number;
}
